<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick" :pageData="pageData" :className="className"></table-page>
    <UPDATE ref="childUpdate" @submit="submit" @changePlatform="changePlatform" :updateData="updateData" :className="className"></UPDATE>
  </div>
</template>

<script>
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    import UPDATE from '@/components/page/update.vue'
    import Qs from 'qs'

    export default {
        name: 'genericList',
        components: {
            tablePage,
            FORM,
            UPDATE
        },
        props: {
            // 接口地址
            apiUrls: {
                type: Object,
                required: true              
            },
            // 查询表单列配置
            formCols: {
                type: Array,
                required: true
            },
            // 新增或更新表单列配置
            updateCols: {
                type: Array,
                required: true
            },
            // 表格列配置
            tableCols: {
                type: Array,
                required: true
            },
            className: {
                type: String,
                required: false
            },
            sequence: {
                type: Boolean,
                default: true,
                required: false
            }
        },

        created() {
            this.formData.cols = this.formCols;
        },
        methods: {
            bthClick(clickName, row, editList = []) {
                if (clickName === "update") {
                    this.$refs.childUpdate.open(row, editList);
                } else if (clickName === "updateApprove") {
                    //approveChange赋值2代表审批，因为需要弹出不同的表单，所以需要在update组件中进行判断
                    row.approveChange = 2;
                    this.$refs.childUpdate.open(row);
                    this.$refs.childUpdate.changeTitle('审批');
                } else if (clickName === "updateCancel") {
                    //approveChange赋值3代表取消，因为需要弹出不同的表单，所以需要在update组件中进行判断
                    row.approveChange = 3;
                    this.$refs.childUpdate.open(row);
                    this.$refs.childUpdate.changeTitle('取消');
                } else if (clickName === "detail") {
                    this.$refs.childUpdate.open(row);
                    this.$refs.childUpdate.changeSubmitBtnStatus(true);
                } else if (clickName === "delete") {
                    this.dataChanage(this.apiUrls.deleteBatchIds, { ids: row.id }, res => {
                        if (res.code === 0) {
                            this.$message.success("suc");
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                } else if (clickName == "approved"){
                    if(row.proposalStatus == 2  || row.approved == 3){
                        this.$message.error("该条数据已审批通过,无需再次审批");
                        return;
                    }
                    this.dataChanage(this.apiUrls.approved, {
                         ids: row.id,type:"2",proposalStatus:2 
                        }, res => {
                        if (res.code === 0) {
                            this.$message.success("审批通过");
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                } else if (clickName == "redo"){
                    if(row.sendStatus == 2  || row.sendStatus == 1){
                        this.$message.error("只有在任务状态完成且发送失败情况下下才能重新发送");
                        return;
                    }
                    this.dataChanage(this.apiUrls.redo, {
                         ids: row.id 
                        }, res => {
                        if (res.code === 0) {
                            this.$message.success("重做成功");
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                } else if (clickName == "cancel"){
                    if(row.proposalStatus == 3 || row.approved == 3){
                        this.$message.error("该条数据已取消,不能再次操作");
                        return;
                    }
                    this.dataChanage(this.apiUrls.approved, {
                         ids: row.id,type:"3",proposalStatus:3
                        }, res => {
                        if (res.code === 0) {
                            this.$message.success("取消完成");
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                } else if (clickName == "cancelTask"){
                    if(row.proposalStatus == 3 || row.approved == 3){
                        this.$message.error("该条数据已取消,不能再次操作");
                        return;
                    }
                    // 取消任务提案和取消米币调整区分URL
                    this.dataChanage(row.creditType ? this.apiUrls.cancel : this.apiUrls.approved, {
                         ids: row.id, type: "3", proposalStatus: 3, ...(row.creditType ? { remark: row.reason} :  { reason: row.reason})
                        }, res => {
                        if (res.code === 0) {
                            this.$message.success("取消完成");
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                } else if (clickName == "status"){
                    this.dataChanage(this.apiUrls.status, {
                         ids: row.id,status:row.isDelete
                        }, 
                        res => {
                            if (res.code === 0) {
                                this.$message.success("success");
                            } else {
                                this.$message.error(res.message);
                            }
                        },
                        fail => {
                            let oldValue = row['isDelete'] === 1 ? 2 : 1;
                            row['isDelete'] = oldValue;
                        }
                    );
                } else if (clickName == "recommend"){
                    this.dataChanage(this.apiUrls.recommend, {
                         ids: row.id,status:row.homeRecommend
                        }, res => {
                        if (res.code === 0) {
                            this.$message.success("success");
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                } else if (clickName == "repeat"){
                    this.dataChanage(this.apiUrls.repeat, {
                         ids: row.id,status:row.repeatStatus
                        }, res => {
                        if (res.code === 0) {
                            this.$message.success("success");
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                } else if (clickName == "copy"){
                    this.dataChanage(this.apiUrls.copy, {
                         ids: row.id}, res => {
                        if (res.code === 0) {
                            this.$message.success("复制成功");
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                } else if (clickName == "back"){
                    if(row.pushStatus != 2){
                        this.$message.error("只有推送成功的数据才能撤回");
                        return;
                    }
                    this.dataChanage(this.apiUrls.back, {
                         ids: row.id
                        }, res => {
                        if (res.code === 0) {
                            this.$message.success("撤回成功");
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                } else if (clickName == "disable"){
                    if(row.status != 1){
                        this.$message.error("该条数据已注销或禁用,无需再次禁用");
                        return;
                    }                
                    this.dataChanage(this.apiUrls.statusHandle, {
                         ids: row.id, type:"2", status:2
                        }, res => {
                        if (res.code === 0) {
                            this.$message.success("禁用成功");
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                } else if (clickName == "unlock"){
                    if(row.status != 4){
                        this.$message.error("该数据只能在解锁状态下进行解锁");
                        return;
                    }
                    this.dataChanage(this.apiUrls.statusHandle, {
                         ids: row.id,type:"4",status:1 
                        }, res => {
                        if (res.code === 0) {
                            this.$message.success("解锁成功");
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                } else if (clickName == "logout"){
                    if(row.status == 3){
                        this.$message.error("该条数据已注销,无需再次注销");
                        return;
                    }
                
                    this.dataChanage(this.apiUrls.statusHandle, {
                         ids: row.id,type:"3",status:3 
                        }, res => {
                        if (res.code === 0) {
                            this.$message.success("注销成功");
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                } else if (clickName == "download"){
                    if (row.url) {
                        window.open(row.url, '_blank');
                    }
                }
            },
            formclick(clickName, data) {
                if ("查询" === clickName || window.$t('mis.bt.search') === clickName) {
                    this.queryData = data;
                    this.$refs.childTable.defaultGetData(data,true);
                } else if (window.$t('mis.bt.add') === clickName) {
                    this.$refs.childUpdate.open();
                }
            },
            submit(model,className = null) {
                this.dataChanage(className === 'miCardLevel' ? this.apiUrls.batchUpdate : this.apiUrls.addOrUpdate, model, res => {
                    if (res.code === 0) {
                        this.$refs.childUpdate.close();
                        this.$message.success("suc");
                    } else {
                        this.$message.error(res.message);
                    }
                });
            },
            changePlatform(value,isOpenFunction) {
                this.$emit("changePlatform", value, isOpenFunction);
            },
            dataChanage(url, option, suc, fail) {
                const isBatchUpdate = url.includes("/batch/update");
                this.$axios.post(url, isBatchUpdate ? JSON.stringify(option) : Qs.stringify(option || {},{ allowDots: true }),{
                    headers: {
                        'Content-Type': isBatchUpdate ? 'application/json' : 'application/x-www-form-urlencoded'
                    }
                }).then(res => {
                    this.$refs.childTable.defaultGetData(this.queryData);
                    if (suc && typeof suc === 'function') suc(res);
                }).catch(res => {
                    this.$refs.childUpdate.disableSubmitBtnStatus(false);
                    if (fail && typeof fail === 'function') fail(res);
                });
            },
            dataChanageGet(url, option, suc, fail) {
                this.$axios.get(url, Qs.stringify(option || {})).then(res => {
                    this.$refs.childTable.defaultGetData(this.queryData);
                    if (suc && typeof suc === 'function') suc(res);
                }).catch(res => {
                    if (fail && typeof fail === 'function') fail(res);
                });
            }
        },
        data() {
            return {
                deleteIds: "",
                queryData: {},
                updateData: {
                    cols: this.updateCols.length > 0 ? this.updateCols : this.tableCols,
                },
                updateData3: {
                    cols: [
                        { title:'id',field:'id',hidden:true },
                        { title: "导入产品", field: 'file', type:34, action:this.apiUrls.import, manual: true },
                    ]
                },
                formData: {
                    hasLable: true,
                    cols: []
                },
                pageData: {
                    isShow: false,
                    queryUrl: this.apiUrls.query,
                    selection: true,
                    sequence: this.sequence,
                    cols: this.tableCols
                }
            };
        }
    }
</script>